import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { selectCounts } from './selectCounts'

export const selectArticlesStateCounts = createSelector(
  selectCounts,
  counts => counts.state || emptyObj
)
